// document.addEventListener("DOMContentLoaded", function(){

// let visibleProducts = document.querySelectorAll('#product-grid .grid__item:not(.hide_this_element)').length;

// document.querySelectorAll('.facet-checkbox__text-label').forEach(el=>{
//   let parent = el.closest('.facet-checkbox__text');
//   if(parent){
//     parent.innerHTML = parent.innerHTML.replace(/\(\d+\)/, '('+visibleProducts+')');
//   }
// });

// });


// #############################################    NEW SCRIPT  ################################

 function refreshSideCart() {    
  fetch("https://www.baiia.com.au/cart?section_id=cart-drawer")
  .then(res => res.text())
  .then(html => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const newDrawer = doc.querySelector("cart-drawer");
    newDrawer.classList.add("appended-drawer");
    const totalQty = parseInt(newDrawer?.getAttribute("data-totalqty") || "0", 10);
    updateCartBubble(totalQty);
    !newDrawer.classList.contains("active") && newDrawer.classList.add("active");
    const existingDrawer = document.querySelector("cart-drawer");
    if (newDrawer && existingDrawer) 
        {
            existingDrawer.replaceWith(newDrawer);
            initializeCartSlider();
        }
    
  });
   }

function initializeCartSlider() {
    const drawer = document.querySelector(".drawer__inner-complete-items");
    const swiperContainer = drawer?.querySelector(".cart-items.swiper");
    if (swiperContainer) {
        // Check if already initialized
        if (swiperContainer.classList.contains("swiper-initialized")) {
            console.log("Swiper already initialized — destroying and reinitializing...");
            swiperContainer.swiper.destroy(true, true); // fully destroy existing swiper
        } else {
            console.log("Swiper not initialized — initializing...");
        }
        // Reinitialize Swiper
        new Swiper('.cart-items.swiper', {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            scrollbar: {
                el: '.swiper-scrollbar',
            },
            loop: false,
        });
    }
}


function updateCartBubble(totalQty) {
  const cartIcon = document.querySelector("#cart-icon-bubble");
  if (!cartIcon) return;

  // Remove any existing bubble first (clean slate)
  const existingBubble = cartIcon.querySelector(".cart-count-bubble");
  if (existingBubble) existingBubble.remove();

  // If there are items in the cart, create and insert bubble
  if (totalQty > 0) {
    const bubbleHTML = `
      <div class="cart-count-bubble">
        <span aria-hidden="true">${totalQty}</span>
        <span class="visually-hidden">${totalQty} item${totalQty > 1 ? "s" : ""}</span>
      </div>
    `;

    // Insert right before closing </a>
    cartIcon.insertAdjacentHTML("beforeend", bubbleHTML);
  }
}

document.addEventListener("DOMContentLoaded", function () {
         
   




  // --- Delegated Click for Add to Cart ---
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".gift-product-add-btn");
    if (!btn) return;

    const select = e.target.closest(".gift-product-cell").querySelector("#GiftProductSelect");
    const variantId = select ? select.value : btn.dataset.variantId;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("✅ Gift product added:", data);
        refreshSideCart();
        autoCheckGiftInCart();
        getCartAndFixShippingProtection();
      })
      .catch((err) => console.error("❌ Error adding gift product:", err));
  });

  // --- Delegated Change for Select (keep button in sync) ---
  document.addEventListener("change", function (e) {
    const select = e.target.closest("#GiftProductSelect");
    if (!select) return;

    const btn = e.target.closest(".gift-product-cell").querySelector(".gift-product-add-btn");

       const imgUrl = select.selectedOptions[0].dataset.imgurl;
 console.log("testtttt111", imgUrl);
  // Check if it exists AND has a value
  if (imgUrl && imgUrl.trim() !== "") {
    const img_target = select.closest(".gift-product-item").querySelector(".gift-product-image img");
    img_target.src = imgUrl;
    console.log("testtttt111");
   
  }

    if (btn) {
      btn.dataset.variantId = select.value;
    }
  });

  // --- Initial call on page load ---
  // updateProgressBar();
});



// add to cart Bundle


document.addEventListener("DOMContentLoaded", function () {
         
   
  // --- Delegated Click for Add to Cart ---
  document.addEventListener("click", function (e) {


  const cartBtn =   e.target.closest(".cart_button");
  if(!cartBtn) return;
  const mainContainer = cartBtn.closest('.bundle-summary');
  const spinner = cartBtn.querySelector('.loading__spinner ');
  if (!mainContainer) return;

  const emptyContainers = mainContainer.querySelectorAll('.empty');

  if (emptyContainers.length > 0) {
    document.querySelector('.notify-wrapper')?.classList.add('error');
    return;
  }


 const productInfo = [];

const productDetailContainers = mainContainer.querySelectorAll('.bundle-item');

productDetailContainers.forEach(productDetail => {
    const pro_info = productDetail.querySelector('.item-info');
    if (!pro_info) return;

    const pro_nameEl = pro_info.querySelector('.item-title');
    const pro_sizeEl = pro_info.querySelector('.item-size');

    const pro_name = pro_nameEl ? pro_nameEl.textContent.trim() : '';
    const pro_size = pro_sizeEl ? pro_sizeEl.textContent.replace('Size:', '').trim() : '';

    // productInfo.push({
    //     Name: pro_name,
    //     Size: pro_size
    // });
    productInfo.push(`${pro_name} - Size ${pro_size}`);
    productInfo.join("\n")
});
console.log(productInfo);

document.querySelector('.notify-wrapper')?.classList.remove('error');

  const bundleId = Number(cartBtn.dataset.bundleId);
  const bundleName = cartBtn.dataset.title;
  const bundlePriceContainer = cartBtn.closest('.bundle-footer');
  console.log(bundlePriceContainer);
  const priceElement = bundlePriceContainer.querySelector('.new-price');
  const bundlePrice = priceElement.querySelector('.money').textContent.trim();

  const bundleTitle = `${productInfo.map(p => `${p.Name} - Size ${p.Size}`).join(" | ")}`;

  if (!bundleId) {
    console.error('Invalid variant ID');
    return;
  }
  if(spinner){
    spinner.classList.remove('hidden');
  }
  cartBtn.classList.add('custom-disable');
  const lineItemProperties = productInfo.reduce((acc, item, index) => {
  acc[`item-${index + 1}`] = item;
  return acc;
}, {});

console.log("Line item properties:", lineItemProperties);

console.log("_productInfo", productInfo);
      fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify({ id: bundleId, quantity: 1,
        properties: {
          // productInfo
          ...lineItemProperties
        }
       }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("✅ bundle product added:", data);
        spinner.classList.add('hidden');
        refreshSideCart();
        autoCheckGiftInCart();
        getCartAndFixShippingProtection();
      })
    .catch((err) => {
       console.error("❌ Error adding bundle product:", err);
     })
    .finally(() => {
      spinner.classList.add("hidden");
      cartBtn.classList.remove('custom-disable');
     });
});


});







document.addEventListener("DOMContentLoaded", function () {
  // --- Progress Bar Function ---
  

  // --- Delegated Click for Add to Cart ---
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".gift-product-add-btn");
    if (!btn) return;

    const select = document.querySelector("#GiftProductSelect");
    const variantId = select ? select.value : btn.dataset.variantId;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("✅ Gift product added:", data);
        // refreshCart(); // reusable

        refreshSideCart();
        autoCheckGiftInCart();
        getCartAndFixShippingProtection();
        // alert("secomf");

      })
      .catch((err) => console.error("❌ Error adding gift product:", err));
  });

  // --- Delegated Change for Select (keep button in sync) ---
  document.addEventListener("change", function (e) {
    const select = e.target.closest("#GiftProductSelect");
    if (!select) return;

    const btn = document.querySelector(".gift-product-add-btn");

      const imgUrl = select.dataset.imgurl;
 console.log("testttt222", imgUrl);
  // Check if it exists AND has a value
  if (imgUrl && imgUrl.trim() !== "") {
    const img_target = select.closest(".gift-product-item").querySelector(".gift-product-image img");
    img_target.src = imgUrl;
    console.log("testttt222");
   
  }
  
    if (btn) {
      btn.dataset.variantId = select.value;
    }
  });

});













document.addEventListener("DOMContentLoaded", function () {
  const SHIPPING_PROTECTION_VARIANT_ID = 41709605912650; // 👈 replace with your variant ID
  console.log("window.shippingProtectionProduct cusom js",window.shippingProtectionProduct);

  // --- Add to cart ---
  function addShippingProtection() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: SHIPPING_PROTECTION_VARIANT_ID, quantity: 1 }]
      })
    })
    .then(res => res.json())
    .then(data => {
      console.log("✅ Shipping protection added:", data);
      // refreshCart(); // 🔥 refresh after add
        refreshSideCart();
         autoCheckGiftInCart();

      return data;
    });
  }

  // --- Remove from cart ---
  function removeShippingProtection() {
    return fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const protectItem = cart.items.find(item => item.variant_id === SHIPPING_PROTECTION_VARIANT_ID);
        if (protectItem) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: protectItem.key, quantity: 0 })
          })
          .then(res => res.json())
          .then(data => {
            console.log("❌ Shipping protection removed:", data);
            // refreshCart(); // 🔥 refresh after remove
        refreshSideCart();
         autoCheckGiftInCart();

            return data;
          });
        }
      });
  }

  // --- Delegated Toggle handler ---
  document.addEventListener('change', function (e) {
    const toggle = e.target.closest('#shippingProtectionToggle');
    if (!toggle) return; // ignore unrelated changes

    // if (toggle.checked) {
    //   addShippingProtection();
    // } else {
    //   removeShippingProtection();
    // }
     if (toggle.checked) {
    getCartAndFixShippingProtection();   // Add / Fix correct shipping protection
  } else {
    removeShippingProtection_customjs(); // Remove all protection variants
  }

  });
});


// #################  START

async function getCartAndFixShippingProtection() {
  try {
    const res = await fetch('/cart.js');
    const parsedState = await res.json();
    await fixShippingProtection_customjs(parsedState);
    
      setTimeout(() => {
          refreshSideCart();
            console.log("🛍️ Cart updated after adding items");
          }, 1000);

  } catch (e) {
    console.error("Error fetching cart:", e);
  }
}


 async function fixShippingProtection_customjs(parsedState) {
  const cartTotal = (parsedState.total_price / 100).toFixed(2);

  // Get correct level
  const return_level_var = getShippingProtectionData(cartTotal);
  if (!return_level_var || !return_level_var.variant) {
    console.warn("No return level found");
    return;
  }

  const correctVariantId = return_level_var.variant;

  // Find all shipping protection products
  const matchedItems = parsedState.items.filter(
    item => item.product_id == window.shippingProtectionProduct
  );

  console.log("Matched shipping protection items:", matchedItems);

  // Remove all WRONG variants
  for (const item of matchedItems) {
    if (item.id != correctVariantId) {
      await fetch(`/cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    }
  }

  // Check if correct variant is already in cart
  const isCorrectInCart = matchedItems.some(item => item.id == correctVariantId);

  // Add correct if missing
  if (!isCorrectInCart) {
    await fetch(`/cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: correctVariantId,
        quantity: 1
      })
    });
  }

  console.log("Shipping protection fixed.");
  
    setTimeout(() => {
          refreshSideCart();
            console.log("🛍️ Cart updated after adding items");
          }, 1000);
}




async function removeShippingProtection_customjs() {
  try {
    const res = await fetch('/cart.js');
    const parsedState = await res.json();

    const matchedItems = parsedState.items.filter(
      item => item.product_id == window.shippingProtectionProduct
    );

    for (const item of matchedItems) {
      await fetch(`/cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    }

    console.log("All shipping protection removed.");
    setTimeout(() => {
          refreshSideCart();
            console.log("🛍️ Cart updated after adding items");
          }, 1000);

  } catch (e) {
    console.error("Error removing shipping protection:", e);
  }
}


// ##################  END


















document.addEventListener("DOMContentLoaded", function () {

  // Safe format money fallback
  function formatMoney(cents) {
    if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.shopCurrencyFormat || "${{amount}}");
    }
    return (cents / 100).toFixed(2); // fallback
  }

  // --- Delegated listener for variant change ---
  document.addEventListener("change", function (e) {
    if (!e.target.classList.contains("rp-variant-select")) return;

    const wrapper = e.target.closest(".related-product");
    const priceDiv = wrapper?.querySelector(".rp-price");

    if (priceDiv) {
      const selectedOption = e.target.options[e.target.selectedIndex];
      const newPrice = selectedOption.dataset.price;
      priceDiv.textContent = formatMoney(newPrice);
    }
  });

  // --- Delegated listener for add-to-cart ---
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".rp-add-btn");
    if (!btn) return;
console.log("clicked relatyed");
    const wrapper = btn.closest(".related-product");
    const select = wrapper.querySelector(".rp-variant-select");
    const variantId = select ? select.value : null;
  
    if (!variantId) return;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(res => res.json())
      .then(data => {
        console.log("✅ Added to cart-rp-variant-select:", data);
        refreshSideCart();
        autoCheckGiftInCart();
        getCartAndFixShippingProtection();
        
      })
      .catch(err => console.error("❌ Add to cart error:", err));
  });

//  add to cart Complete the set

  document.addEventListener("click", function (e) {
    const complete_btn = e.target.closest(".complete_set_btn");
    if (!complete_btn) return;
    const wrapper = complete_btn.closest(".related-product");
    const select = wrapper.querySelector(".rp-variant-item.active");
    console.log(select);
    const variantId = select ? select.dataset.variantId : null;
    console.log(variantId);
    console.log('herehe');
  
    if (!variantId) return;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(res => res.json())
      .then(data => {
        console.log("✅ Added to cart-rp-variant-select:", data);
        refreshSideCart();
        autoCheckGiftInCart();
        getCartAndFixShippingProtection();
        
      })
      .catch(err => console.error("❌ Add to cart error:", err));
  });


    // --- Delegated listener for add-to-cart Recently reveiwed product at empty cart ---
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".rp-add-btn-recent-review");
    if (!btn) return;

    const wrapper = btn.closest(".related-product");
    const select = wrapper.querySelector(".rp-variant-select");
    const variantId = select ? select.value : null;

    if (!variantId) return;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(res => res.json())
      .then(data => {
        console.log("✅ Added to cart-rp-add-btn-recent-review:", data);
        // if (typeof refreshCart === "function") refreshCart(); // 🔥 only call if available
        console.log("adddedd recent");
        refreshSideCart();
        autoCheckGiftInCart();

      })
      .catch(err => console.error("❌ Add to cart error:", err));
  });

});










document.addEventListener("DOMContentLoaded", function () {
  const menuHeads = document.querySelectorAll(".footer_menu_head");

  menuHeads.forEach(head => {
    head.addEventListener("click", function () {
      const menu = this.nextElementSibling;
      const parentBlock = this.closest(".footer-block");

      if (menu && menu.classList.contains("foot_menu_ul")) {
        const isAlreadyActive = parentBlock.classList.contains("_active");

        // Close all menus + remove active
        document.querySelectorAll(".foot_menu_ul").forEach(ul => {
          ul.classList.add("hide_foot_menu");
        });
        document.querySelectorAll(".footer-block").forEach(block => {
          block.classList.remove("_active");
        });

        // If it wasn't active before, activate it
        if (!isAlreadyActive) {
          menu.classList.remove("hide_foot_menu");
          parentBlock.classList.add("_active");
        }
      }
    });
  });
});



document.addEventListener("DOMContentLoaded", () => {
  // Select container (so you can reuse this code for multiple product cards)
  document.querySelectorAll(".variant-add-to-cart-on-hover-outer").forEach(wrapper => {
    const variantList = wrapper.querySelector(".on-hover-variant-list");
    const addToCartBtn = wrapper.querySelector(".add-to-cart-btn");

    if (!variantList || !addToCartBtn) return;

    const variantItems = variantList.querySelectorAll(".variant-item");

    // Handle variant item click
    variantItems.forEach(item => {
      item.addEventListener("click", () => {
        // Remove 'selected' from all, add to clicked
        variantItems.forEach(i => i.classList.remove("selected"));
        item.classList.add("selected");

         item.insertAdjacentHTML(
          "beforeend",
          `
          <div class="variant-add-cart-on-hover-loading__spinner">
            <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
              <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
            </svg>
          </div>
          `
        );


        // Update Add to Cart button with selected variant id
        const selectedId = item.dataset.variantId;
        addToCartBtn.setAttribute("data-addcart", selectedId);
         addToCartBtn.click();
      });
    });

    // Handle Add to Cart click
    addToCartBtn.addEventListener("click", () => {
      
      const selectedVariantId = addToCartBtn.getAttribute("data-addcart");
      if (!selectedVariantId) {
        alert("Please select a variant first.");
        return;
      }

      const spinner = addToCartBtn.querySelector(".variant-add-cart-on-hover-loading__spinner");
      if (spinner) {
      spinner.classList.remove("hidden");
      }

      // Add to cart via Shopify AJAX
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
      })
      .then(res => res.json())
      .then(data => {
        console.log("✅ Added to cart:", data);
         if (spinner) {
         spinner.classList.add("hidden");
          }
          const cartDrawer = document.querySelector('cart-drawer');

          if (cartDrawer) {
            cartDrawer.classList.add('active');
            console.log('✅ "active" class added to <cart-drawer>');
          } 
        // alert(`${data.title} added to cart!`);
        //  refreshCart(); // refresh cart after adding
        refreshSideCart();
        autoCheckGiftInCart();
        getCartAndFixShippingProtection();   // Add / Fix correct shipping protection


        
        //  initCartSwipers();
       addToCartBtn.closest(".variant-add-to-cart-on-hover-outer").querySelector(".variant-add-cart-on-hover-loading__spinner").remove();
        
        // Optional: trigger cart drawer refresh here
      })
      .catch(err => {
        console.error("❌ Add to cart failed:", err);
        if (spinner) {
         spinner.classList.add("hidden");
          }
           addToCartBtn.closest(".variant-add-to-cart-on-hover-outer").querySelector(".variant-add-cart-on-hover-loading__spinner").remove();
        // alert("Error adding to cart. Please try again.");
      });
    });
  });
});







// sticky add to cart at product page
 document.addEventListener("DOMContentLoaded", () => {

// window.addEventListener("scroll", () => {
//   const variantEl = document.querySelector("variant-selects");
//   const productButtons = document.querySelector(".default_product_page .product-form__buttons");
//   if (!variantEl || !productButtons) return;

//   const rect = variantEl.getBoundingClientRect();
//   const threshold = 50; // 👈 small scroll detection (adjust as needed)

//   // If the element’s bottom is above the viewport + threshold → remove sticky
//   if (rect.bottom < -threshold) {
//     document.body.classList.remove("stick-btn");
//     productButtons.classList.remove("stick");
//     console.log("⬆️ variant-selects scrolled above (beyond threshold)");
//   } 
//   // If element is still in view or only slightly above → add sticky
//   else {
//     document.body.classList.add("stick-btn");
//     productButtons.classList.add("stick");
//     console.log("⬇️ variant-selects visible or just slightly above");
//   }
// });
function handleStickyButtons() {
  const productButtons = document.querySelector(".default_product_page .product-form__buttons");
  if (!productButtons) return;

  // Detect even the smallest scroll — 0.5px threshold
  const scrollY = window.scrollY || window.pageYOffset;

  if (scrollY <= 0) {
    // ✅ User at very top — remove sticky
    document.body.classList.remove("stick-btn");
    productButtons.classList.remove("stick");
    console.log("🔝 At top — remove sticky");
  } else {
    // ✅ Any small scroll — add sticky
    document.body.classList.add("stick-btn");
    productButtons.classList.add("stick");
    console.log("⬇️ Small scroll detected — add sticky");
  }
}

// Run once on load
handleStickyButtons();

// Listen for scroll (captures even tiny scroll movement)
window.addEventListener("scroll", handleStickyButtons, { passive: true });





 });










// custom product slider product page
// document.addEventListener("click", function (e) {
//   const prevBtn = e.target.closest(".slider-mobile-gutter-custom .slider-button--prev");
//   const nextBtn = e.target.closest(".slider-mobile-gutter-custom .slider-button--next");

//   // Only run if clicking inside the correct slider controls
//   if (!prevBtn && !nextBtn) return;

//   // Find the nearest media-gallery and its thumbnail list
//   const mediaGallery = e.target.closest("media-gallery");
//   if (!mediaGallery) return;

//   const slider = mediaGallery.querySelector(".thumbnail-slider-dots");
//   if (!slider) return;

//   const thumbnails = Array.from(slider.querySelectorAll("button.thumbnail"));
//   const currentIndex = thumbnails.findIndex(btn => btn.getAttribute("aria-current") === "true");
//   if (currentIndex === -1) return; // No active found

//   let targetIndex = currentIndex;

//   // Handle NEXT click
//   if (nextBtn) {
//     targetIndex = Math.min(currentIndex + 1, thumbnails.length - 1);
//   }

//   // Handle PREV click
//   if (prevBtn) {
//     targetIndex = Math.max(currentIndex - 1, 0);
//   }

//   // Update aria-current
//   if (targetIndex !== currentIndex) {
//     thumbnails[currentIndex].removeAttribute("aria-current");
//     thumbnails[targetIndex].setAttribute("aria-current", "true");

//     // ✅ Trigger a click on the new active thumbnail
//     thumbnails[targetIndex].click();

//     // Optionally scroll it into view if needed
//     thumbnails[targetIndex].scrollIntoView({
//       behavior: "smooth",
//       block: "nearest",
//       inline: "center"
//     });
//   }

//   // ✅ Disable or enable buttons based on position
//   if (prevBtn || nextBtn) {
//     const parentSlider = e.target.closest(".slider-mobile-gutter-custom");
//     const prev = parentSlider.querySelector(".slider-button--prev");
//     const next = parentSlider.querySelector(".slider-button--next");

//     if (prev && next) {
//       prev.disabled = targetIndex === 0;
//       next.disabled = targetIndex === thumbnails.length - 1;
//     }
//   }
// });







function autoCheckGiftInCart() {
  fetch(`/cart.js`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => response.text())
    .then(state => {
      const parsedState = JSON.parse(state);
      console.log("🛒 Cart items:", parsedState.items);
      console.log("🔢 Total quantity:", parsedState.item_count);
      autoAddProduct(parsedState);
    })
    .catch(err => console.error('Error fetching cart:', err));
}


// ========================
// AUTO ADD / REMOVE GIFTS
// ========================
function autoAddProduct(parsedState) {
  const rows = document.querySelectorAll('tbody.gift-product-body tr[data-autoadd="true"]');
  if (!rows.length) {
    console.log("No auto-add rows found");
    return;
  }

  const cartTotalCustom = parsedState.original_total_price / 100;
  const itemsToAdd = [];
  const itemsToRemove = [];

  // rows.forEach(tr => {
  //   const autoProdId = parseInt(tr.getAttribute("data-prodid"));
  //   const autoProdThreshold = parseInt(tr.getAttribute("data-threeshhold"));
  //   if (!autoProdId || !autoProdThreshold) return;

  //   const freeProductInCart = parsedState.items.find(item => item.id === autoProdId);

  //   if (cartTotalCustom >= autoProdThreshold) {
  //     if (!freeProductInCart) {
  //       itemsToAdd.push({ id: autoProdId, quantity: 1 });
  //     } else if (freeProductInCart.quantity > 1) {
  //       updateFromCart(freeProductInCart.key, 1);
  //     }
  //   } else if (freeProductInCart) {
  //     itemsToRemove.push(freeProductInCart.key);
  //   }
  // });

    rows.forEach(tr => {
  const autoProdId = parseInt(tr.getAttribute("data-prodid"));
  const autoProdThreshold = parseInt(tr.getAttribute("data-threeshhold"));
  if (!autoProdId || !autoProdThreshold) return;

  const freeProductInCart = parsedState.items.find(item => item.id === autoProdId);

  // If cart total meets or exceeds threshold
  if (cartTotalCustom >= autoProdThreshold) {
    if (!freeProductInCart) {
      // ✅ Add the gift if not already in cart
      itemsToAdd.push({
        id: autoProdId,
        quantity: 1
      });
    } else if (freeProductInCart.quantity > 1) {
      // ✅ Normalize quantity to 1 if multiple exist
      updateFromCart(freeProductInCart.key, 1);
    }
  } 
  // If cart total is less than threshold
  else {
    if (freeProductInCart) {
      // ✅ Remove this product since threshold not met
      itemsToRemove.push(freeProductInCart.key);
    }
  }
});

  console.log("🟢 Items to add custom.js:", itemsToAdd);
  console.log("🔴 Items to remove custom.js:", itemsToRemove);

  if (itemsToAdd.length) addToCart(itemsToAdd);
  if (itemsToRemove.length) removeMultipleItems(itemsToRemove);
}



// ========================
// ADD TO CART
// ========================
function addToCart(items) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  })
    .then(() => fetch(`${routes.cart_url}?section_id=cart-drawer`))
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const newCartDrawer = html.querySelector("cart-drawer");
      const currentCartDrawer = document.querySelector("cart-drawer");

      if (newCartDrawer && currentCartDrawer) {
        currentCartDrawer.replaceWith(newCartDrawer);
        newCartDrawer.classList.add("active");
        setTimeout(() => {
          refreshSideCart();
          console.log("🛍️ Cart updated after adding items");
        }, 1000);
      }
    });
}



// ========================
// UPDATE CART ITEM QUANTITY
// ========================
function updateFromCart(itemKey, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: itemKey, quantity: qty })
  })
    .then(() => fetch(`${routes.cart_url}?section_id=cart-drawer`))
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const newCartDrawer = html.querySelector("cart-drawer");
      const currentCartDrawer = document.querySelector("cart-drawer");

      if (newCartDrawer && currentCartDrawer) {
        currentCartDrawer.replaceWith(newCartDrawer);
        newCartDrawer.classList.add("active");
        setTimeout(() => {
          refreshSideCart();
          console.log("🔄 Cart updated after quantity change");
        }, 1000);
      }
    });
}



// ========================
// REMOVE MULTIPLE ITEMS
// ========================
function removeMultipleItems(keys = []) {
  if (!keys.length) return;

  const updates = {};
  keys.forEach(key => updates[key] = 0);

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  })
    .then(res => res.json())
    .then(updatedCart => {
      console.log('🧹 Removed multiple items:', keys);
      console.log('🆕 Updated cart:', updatedCart);
    })
    .catch(err => console.error('Multi-remove failed:', err));
}




















// popup fit size at the product page

// const trigger = document.querySelector(".find-fit");
//   const popup = document.querySelector(".product_find_size");
//   const closeBtn = popup.querySelector(".close");
//   const overlay = popup.querySelector(".find-size-overlay");

//   // if (!trigger || !popup) return;

//   // 🟢 Show popup
//   trigger.addEventListener("click", () => {
//     popup.classList.remove("hidden");
//     document.body.classList.add("no-scroll"); // optional: prevent page scroll
//   });

//   // 🔴 Hide popup (close button or overlay click)
//   const closePopup = () => {
//     popup.classList.add("hidden");
//     document.body.classList.remove("no-scroll");
//   };

//   closeBtn.addEventListener("click", closePopup);
//   overlay.addEventListener("click", closePopup);
// setTimeout(() => {
//     if (typeof window.initFindSize === 'function') {
//       window.initFindSize(); // re-initialize your logic
//     }
//   }, 100);


const trigger = document.querySelector(".find-fit");
const popup = document.querySelector(".product_find_size");

// ✅ Only run if popup exists
if (popup) {
  const closeBtn = popup.querySelector(".close");
  const overlay = popup.querySelector(".find-size-overlay");

  // 🟢 Show popup (only if trigger exists)
  if (trigger) {
    trigger.addEventListener("click", () => {
      popup.classList.remove("hidden");
      document.body.classList.add("no-scroll");
    });
  }

  // 🔴 Hide popup
  const closePopup = () => {
    popup.classList.add("hidden");
    document.body.classList.remove("no-scroll");
  };

  // ✅ Safe bindings
  if (closeBtn) {
    closeBtn.addEventListener("click", closePopup);
  }

  if (overlay) {
    overlay.addEventListener("click", closePopup);
  }
}

// ✅ Safe init (independent)
setTimeout(() => {
  if (typeof window.initFindSize === "function") {
    window.initFindSize();
  }
}, 100);


// ##########################  custom code for the variant change on click variants  START #######################

document.addEventListener("click", async (e) => {
  const opener = e.target.closest(".cstm-quick-drawer-swaches");
  if (!opener) return;

  e.preventDefault();

  const url = opener.getAttribute("data-suburl");
  if (!url) return;

  try {
    // 👉 Fetch product page
    const response = await fetch(url);
    const responseText = await response.text();

    // 👉 Parse HTML
    const responseHTML = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );

    const newProductInfo = responseHTML.querySelector("product-info");
    const currentProductInfo = document.querySelector("product-info");

    if (!newProductInfo || !currentProductInfo) return;

    // 👉 Replace product-info
    currentProductInfo.replaceWith(newProductInfo);

    // 👉 INIT SWIPER AFTER REPLACE
    initCustomSwiper(newProductInfo);

  } catch (err) {
    console.error("Error loading product:", err);
  }
});


// ==========================
// 🔥 SWIPER LOGIC
// ==========================
function initCustomSwiper(container) {
  const productGallery = container.querySelector('[id^="Slider-Gallery"]');

  if (!productGallery) {
    console.warn("⚠️ No product gallery found");
    return;
  }

  // ❌ Prevent duplicate
  if (container.querySelector(".myProductSwiper")) return;

  // 👉 Get images
  const slides = productGallery.querySelectorAll('[id^="Slide-"] img');

  const imageUrls = [...slides]
    .map((img) => img.src)
    .filter(Boolean);

  if (!imageUrls.length) {
    console.warn("⚠️ No images found");
    return;
  }

  // 👉 Create Swiper HTML
  const swiperContainer = document.createElement("div");
  swiperContainer.className = "swiper myProductSwiper";

  swiperContainer.innerHTML = `
    <div class="swiper-wrapper">
      ${imageUrls
        .map(
          (url, i) => `
          <div class="swiper-slide">
            <img src="${url}" alt="Product Image ${i + 1}" loading="lazy">
          </div>`
        )
        .join("")}
    </div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  `;

  // 👉 Insert after gallery
  productGallery.insertAdjacentElement("afterend", swiperContainer);

  // 👉 Hide original gallery
  productGallery.style.display = "none";

  // 👉 Load Swiper + Init
  loadSwiperAssets().then(() => {
    new Swiper(swiperContainer, {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: swiperContainer.querySelector(".swiper-button-next"),
        prevEl: swiperContainer.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 2 },
      },
    });
  });
}


// ==========================
// ⚡ LOAD SWIPER (ONCE)
// ==========================
function loadSwiperAssets() {
  const cssHref = "https://unpkg.com/swiper@9/swiper-bundle.min.css";
  const jsSrc = "https://unpkg.com/swiper@9/swiper-bundle.min.js";

  return new Promise((resolve, reject) => {
    // 👉 Load CSS once
    if (!document.querySelector(`link[href="${cssHref}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = cssHref;
      document.head.appendChild(link);
    }

    // 👉 If already loaded
    if (window.Swiper) return resolve();

    // 👉 Load JS
    const script = document.createElement("script");
    script.src = jsSrc;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}


// ##########################  custom code for the variant change on click variants  END #######################